import styled from "styled-components";

import { Dialog, DialogContent } from "@material-ui/core";

const primary = (props) => props.theme.palette.primary;
const blue = (props) => props.theme.palette.blue;
const secondary = (props) => props.theme.palette.secondary;
const lightgreen = (props) => props.theme.palette.lightgreen;

const montserrat = (props) => props.theme.fonts.montserrat;
const mulish = (props) => props.theme.fonts.mulish;
const opensans = (props) => props.theme.fonts.opensans;

export const Header = styled.div`
  width: 100%;
`;

export const Body = styled.div`
  width: 100%;
`;

export const DialogContentStyled = styled(DialogContent)`
  max-height: 55vh;
  overflow-y: scroll;
`;

export const CustomDialog = styled(Dialog)`
  .MuiDialog-paperScrollPaper {
    &::-webkit-scrollbar {
      width: 12px;
    }
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 5px;
    }
    ::-webkit-scrollbar-thumb {
      background: ${primary};
      border-radius: 5px;
      border: 1px solid #f1f1f1;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: ${blue};
    }
  }
`;

export const StyledDialog = styled.div`
  .MuiDialogContent-root {
    padding: 0px 24px;
  }

  Button {
    span {
      font-family: ${mulish};
      font-weight: bolder;
      font-size: 0.975rem;
    }
  }

  ${Header} {
    .MuiChip-root {
      width: 100%;
      padding: 10px;
      margin: 0;

      .MuiChip-label {
        font-family: ${mulish};
        font-weight: bolder;
        font-size: 1rem;
      }
    }
  }

  ${Body} {
    ${Header} {
      margin-top: 10px;
    }

    Table {
      Thead {
        background-color: ${secondary};
        box-shadow: 3px 3px 3px ${(props) => props.theme.palette.darkgrey};
        tr {
          .Mui-checked {
            color: ${primary};
          }
          th {
            span {
              font-family: ${montserrat}, sans-serif !important;
            }
          }
        }
      }
      Tbody {
        td {
          font-family: ${opensans};
          .Mui-checked {
            color: ${primary};
          }
        }
        .Mui-selected {
          background-color: ${lightgreen};
          &:hover {
            background-color: ${lightgreen};
          }
          border: none;
        }
      }
    }
  }
`;
